import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ReqsparepartPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-reqsparepart',
  templateUrl: 'reqsparepart.html',
})
export class ReqsparepartPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReqsparepartPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/reqsparepart/reqsparepart.ts